import { FC, MouseEvent } from 'react';
import classnames from 'classnames';

import { Icon } from '../../icon';
import { IconWithTooltip } from '../../iconWithTooltip';
import { useInputError } from '../hooks/useInputError';
import { InputWrapper, InputWrapperProps } from '../InputWrapper';

import './Checkbox.scss';

export type InputCheckboxProps = InputWrapperProps & {
  checked?: boolean;
  className?: string;
  label?: string;
  labelClassName?: string;
  onChange: (checked: boolean, name: string) => void;
  testId?: string;
  tooltip?: string;
};

export const Checkbox: FC<InputCheckboxProps> = ({
  checked,
  className,
  label,
  labelClassName,
  onChange,
  testId,
  tooltip,
  ...wrapperProps
}) => {
  const { disabled, labelIcon, name, validation } = wrapperProps;
  const { setDirty, showError } = useInputError(validation);

  const onClick = (event: MouseEvent) => {
    if (!disabled) {
      event.stopPropagation();
      onChange(!checked, name);
      setDirty();
    }
  };

  const renderCheckbox = () => (
    <Icon
      disabled={disabled}
      label={name}
      name={checked ? 'checkboxChecked' : 'checkbox'}
      onClick={onClick}
      size={2.4}
      testId={testId}
    />
  );

  return (
    <InputWrapper className={classnames('checkbox-wrapper', className)} {...wrapperProps} showError={showError}>
      <div className={classnames({ 'is-checked': checked })}>
        {renderCheckbox()}
        <label
          className={classnames(labelClassName, { disabled: disabled, 'is-error': showError })}
          onClick={onClick}
          role="presentation"
        >
          {label}
        </label>
        {!!labelIcon && !!tooltip ? <IconWithTooltip iconName={labelIcon} label={tooltip} /> : null}
      </div>
    </InputWrapper>
  );
};
